<script setup>
import AppLayout from '@/Layouts/AppLayout.vue'
import StudentTermsContent from '@/Components/Legal/StudentTermsContent.vue'
</script>

<template>
  <AppLayout>
    <div class="max-w-4xl mx-auto px-4 py-16">
      <h1 class="text-4xl font-bold text-gray-900 mb-8">Bindle – Student Terms & Conditions</h1>
      <StudentTermsContent />
    </div>
  </AppLayout>
</template>
